module.exports = __webpack_public_path__ + "img/forgot-password-v2.8361cf90.png";